import Glide from "../node_modules/@glidejs/glide/dist/glide.esm.js";

window.addEventListener("load", function () {
  new Glide(".glide", {
    //
    type: "carousel",
    autoplay: 8000,
    animationDuration: 0,
    gap: 0,
  }).mount();
});
